import { object, string } from "yup";

export const validations = object().shape({
  name: string().required(),
  ososUsername: string().optional(),
  ososPassword: string().optional(),
});
